import { useState } from 'react';
import Footer from './Footer';
import Header from './Header';

function Contact(lang) {
    const [formData,setFormData] = useState({
        name:"",
        surname:"",
        email:"",
        message:""
    });
    const handleChange = (e)=>{
        const {name,value} = e.target;
        setFormData({
            ...formData,
            [name]:value
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if(formData.name==="" || formData.surname==="" || formData.message===""){
            document.getElementById("error").innerHTML="Fill all fields"
            document.getElementById("button").style.opacity="0";
            setTimeout(()=>{
                document.getElementById("error").style.opacity="1";
            },"500")
            setTimeout(()=>{
                document.getElementById("error").style.opacity="0";
                setTimeout(()=>{
                    document.getElementById("button").style.opacity="1";
                },"500")
            },"3000")
            
        }
        else if(!formData.email.includes("@")&&!formData.email.includes(".")){
            document.getElementById("error").innerHTML="Enter correct email"
            document.getElementById("button").style.opacity="0";
            setTimeout(()=>{
                document.getElementById("error").style.opacity="1";
            },"500")
            setTimeout(()=>{
                document.getElementById("error").style.opacity="0";
                setTimeout(()=>{
                    document.getElementById("button").style.opacity="1";
                },"500")
            },"3000")
             
        }
        else{
            try {
                const response = await fetch("https://teletelbackend-nlzt.onrender.com/submit", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                });
        
                const result = await response.json();
                console.log("Response from server:", result);
            } catch (error) {
                console.error("Error submitting form:", error);
            }
        }
        
    }
    if(lang.lang==="pl"){
        return (
            <div className='App' style={{textAlign:"center"}}>
    
                <Header />
                <br />
                <h3>SKONTAKTUJ SIĘ Z NAMI JUŻ TERAZ</h3>
                <h1>Kontakt</h1>
                <br />
                <h2 style={{marginTop:"50px",marginBottom:"50px"}}>Będziemy szczęśliwi wspierać twój biznes</h2>
                <div className='contactgrid'>
                    <div className='form'>
                        <h2>Napisz do nas</h2>
                        <h3>Skontaktuj się z nami i zrealizuj swoje biznesowe marzenia w Polsce – jesteśmy tu, aby Ci pomóc!</h3>
                        <form name="contact" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="input-group" id="half">
                                    <label htmlFor="name">Imię</label>
                                    <input type="text" id="name" name='name' value={formData.name} onChange={handleChange} placeholder="Twoje imię" />
                                </div>
    
                                <div className="input-group" id='half'>
                                    <label htmlFor="surname">Nazwisko</label>
                                    <input type="text" id="surname" name='surname' value={formData.surname} onChange={handleChange} placeholder="Twoje nazwisko" />
                                </div>
                            </div>
    
                            <div className="input-group">
                                <label htmlFor="email">Twój email</label>
                                <input type="email" id="email" name='email' value={formData.email} onChange={handleChange} placeholder="Twój email" />
                            </div>
    
                            <div className="input-group">
                                <label htmlFor="message">Wiadomość</label>
                                <textarea type="text" id="message" name='message' value={formData.message} onChange={handleChange} placeholder="Wprowadź swoją wiadomość tutaj" />
                            </div>
                            <div id='error'>
                                <h3></h3>
                            </div>
                            <input id='button' type='submit' value="WYŚLIJ" />
                        </form>
                    </div>
                    <div className='info'>
                        <img src='/contact.webp' />
                        <h2>Informacje kontaktowe</h2>
                        <br/>
                        <div className='infos'><img src='/location.webp' />
                            <div className='column'>
                                <h3>Ul. Wadowicka 6 </h3>
                                <h3>Kraków, 30-415</h3>
                            </div>
                            
                        </div>
                        <div className='infos'><img src='/phone.webp' />
                        <h3>+48 730-025-598</h3>
                        
                        </div>
                        <div className='infos'><img src='/email.webp' />
                        <h3>teletel.ksiegowosc@gmail.com</h3>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
    if(lang.lang==="ua"){
        return (
            <div className='App' style={{textAlign:"center"}}>
    
                <Header />
                <br />
                <br/>
                <h1>Контакт</h1>
                <br />
                <h2 style={{marginTop:"50px",marginBottom:"50px"}}>Ми будемо раді допомогти</h2>
                <div className='contactgrid'>
                    <div className='form'>
                        <h2>Напишіть до нас </h2>
                        <h3>Зв'яжіться з нами та здійсніть свої мрії в Польщі - ми тут, щоб допомогти вам!</h3>
                        <form name="contact" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="input-group" id="half">
                                    <label htmlFor="name">Ім'я</label>
                                    <input type="text" id="name" name='name' value={formData.name} onChange={handleChange} placeholder="Твоє ім'я" />
                                </div>
    
                                <div className="input-group" id='half'>
                                    <label htmlFor="surname">Прізвище</label>
                                    <input type="text" id="surname" name='surname' value={formData.surname} onChange={handleChange} placeholder="Твоє призвіще" />
                                </div>
                            </div>
    
                            <div className="input-group">
                                <label htmlFor="email">Твій e-mail:</label>
                                <input type="email" id="email" name='email' value={formData.email} onChange={handleChange} placeholder="Твій email" />
                            </div>
    
                            <div className="input-group">
                                <label htmlFor="message">Повідомлення:</label>
                                <textarea type="text" id="message" name='message' value={formData.message} onChange={handleChange} placeholder="Введіть своє повідомлення тут" />
                            </div>
                            <div id='error'>
                                <h3></h3>
                            </div>
                            <input id='button' type='submit' value="ВІДПРАВИТИ" />
                        </form>
                    </div>
                    <div className='info'>
                        <img src='/contact.webp' />
                        <h2>Контактна інформація</h2>
                        <br/>
                        <div className='infos'><img src='/location.webp' />
                            <div className='column'>
                                <h3>Ul. Wadowicka 6 </h3>
                                <h3>Kraków, 30-415</h3>
                            </div>
                            
                        </div>
                        <div className='infos'><img src='/phone.webp' />
                        <h3>+48 730-025-598</h3>
                        
                        </div>
                        <div className='infos'><img src='/email.webp' />
                        <h3>teletel.ksiegowosc@gmail.com</h3>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
   

}

export default Contact;